
export const ADMIN_COMMANDES_INITIATE_FETCH_LISTE_COMMANDES = 'ADMIN_COMMANDES_INITIATE_FETCH_LISTE_COMMANDES';
export const ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_START = 'ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_START';
export const ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_SUCCESS = 'ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_SUCCESS';
export const ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_FAIL = 'ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_FAIL';
export const ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_RESET = 'ADMIN_COMMANDES_FETCH_LISTE_COMMANDES_RESET';